import { appConfig } from '@/shared/config';

export const withDebugBar = async () => {
  if (appConfig.isProdRuntimeEnv) {
    return;
  }
  const { debugBar } = await import('@freedom/debug-bar');
  debugBar.init();
};
